import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';
import { initializeTemporarySuccess, revokeTemporarySuccess } from 'src/actions/initialize';
import { Unauthorized, NotExistError } from '@ad-scripts/application/lib/error';

export interface Organizations {
  id: string;
  loginDomain?: string;
  name?: string;
  timezone: string;
  gladlyUrl: string;
}

// You get 2 minutes to imitate a user before the page refreshes. Safety mechanism - probably overkill
const imitateLogoutMs = 120 * 1000;

const organizationsResource = createCollectionResource<Organizations>({
  name: 'organizations',
  endpoint: 'v1/organizations',
  observerCreator: emptyObserverCreator,
});

const fetchAll: sharedTypes.AppThunk =
  (params: any) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(fetchStarted({}));
      const result = await gateways.organizations.requestAll(params);
      dispatch(fetchSuccess(result));
      dispatch(initializeTemporarySuccess());
      setTimeout(() => {
        dispatch(revokeTemporarySuccess());
      }, imitateLogoutMs);
    } catch (err) {
      if (err instanceof Unauthorized || err instanceof NotExistError) {
        // redirect to supernova to login in through okta
        window.location.assign(`/api/v2/admin_tokens?returnTo=/admin/imitate`);
      } else {
        dispatch(fetchRequestError({}));
      }
    }
  };

organizationsResource.effects.fetchAll = fetchAll;
const { fetchStarted, fetchSuccess, fetchRequestError } = organizationsResource.actions;

export default organizationsResource;
export { fetchAll };
